// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Taiwan from '../_raw/flag/icon_flag_taiwan.png';

export default () => <img src={Taiwan} alt="Taiwan" />;
